<!-- Modal Backdrop -->
<div class="modal-backdrop fade show" (click)="onCancel()"></div>

<!-- Modal -->
<div class="modal fade show d-block" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Assign Ticket</h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- Ticket Context -->
        <div class="mb-3 p-3 bg-body-tertiary rounded">
          <small class="text-muted d-block">Ticket</small>
          <strong>#{{ ticket.ticketNumber }}</strong> - {{ ticket.subject }}
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="alert alert-danger py-2">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          {{ errorMessage }}
        </div>

        <!-- Organization Select -->
        <div class="mb-3">
          <label for="organizationSearch" class="form-label">Organization <span class="text-danger">*</span></label>
          <input
            type="text"
            id="organizationSearch"
            class="form-control mb-2"
            placeholder="Search organizations..."
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()"
          />
          <select
            id="organizationSelect"
            class="form-select"
            [(ngModel)]="selectedOrganizationId"
            [disabled]="loadingOrganizations"
          >
            <option value="">-- Select Organization --</option>
            <option *ngFor="let org of filteredOrganizations" [value]="org.id">
              {{ org.name }}
            </option>
          </select>
          <div *ngIf="loadingOrganizations" class="form-text">
            <span class="spinner-border spinner-border-sm me-1" role="status"></span>
            Loading organizations...
          </div>
        </div>

        <!-- Profile ID (Optional) -->
        <div class="mb-3">
          <label for="profileId" class="form-label">Profile ID <small class="text-muted">(optional)</small></label>
          <input
            type="text"
            id="profileId"
            class="form-control"
            placeholder="Link to a specific user profile"
            [(ngModel)]="profileId"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!selectedOrganizationId || loading"
          (click)="onAssign()"
        >
          <span *ngIf="loading" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Assign
        </button>
      </div>
    </div>
  </div>
</div>
